import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { SettingsDTO } from '../common/types/settings';
import { FilterData, IdentificationData, OwnOrganisationsAndSites } from '../common/types/common';
import { SETTINGS_FILTER_DATA, OWN_ORGANISATIONS_AND_SITES, toastrConfig } from '../app.config';
import { onOrganisationChange } from '../common/utils';
import { SettingsService } from '../common/services/settings.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { HttpParams } from '@angular/common/http';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  encapsulation: ViewEncapsulation.None
})
export class SettingsComponent implements OnInit {
  isLoading = false;
  activeTab = 1;
  settingsData: SettingsDTO = {
    maxInsiders: null,
    alertLimit: null,
    openTime: null,
    closeTime: null,
    closeIsOnSameDay: null
  };

  storedFilters: FilterData = null;
  ownOrganisationsAndSites: OwnOrganisationsAndSites[];
  organisations: IdentificationData[];
  sites: any[];
  selectedOrganisation: any = {id: null};
  selectedSite: any = {id: null, name: null};

  constructor(private settingsServices: SettingsService,
              private toastr: ToastrService,
              private translateService: TranslateService) { }

  ngOnInit() {
    this.isLoading = true;
    this.storedFilters = JSON.parse(localStorage.getItem(SETTINGS_FILTER_DATA));
    this.ownOrganisationsAndSites = JSON.parse(localStorage.getItem(OWN_ORGANISATIONS_AND_SITES));
    this.organisations = this.ownOrganisationsAndSites.map(item => item.organisation);

    if (this.organisations.length > 0) {
      this.selectedOrganisation = this.organisations.find(o => o.id === this.storedFilters?.selectedOrganisation?.id) || this.organisations[0];
      this.sites = onOrganisationChange(this.ownOrganisationsAndSites, this.selectedOrganisation.id);
      this.selectedSite = this.sites.find(s => s.id === this.storedFilters?.selectedSite?.id) || this.sites[0];
      this.getSettings();
    } else {
      this.isLoading = false;
    }
  }

  onOrganisationChanged(selectedOrganisation: any) {
    this.selectedOrganisation = selectedOrganisation;
    this.sites = onOrganisationChange(this.ownOrganisationsAndSites, this.selectedOrganisation.id);
    this.selectedSite = this.sites[0];
  }

  tabChangedEvent(event: any) {
    this.settingsData = { ...this.settingsData, ...event };
  }

  getSettings() {
    this.isLoading = true;
    const params = new HttpParams()
      .set('site', this.selectedSite.id)
      .set('organisation', this.selectedOrganisation.id);

    this.settingsServices.getSettings(params).subscribe({
      next: (data: SettingsDTO[]) => {
        this.settingsData = data[0];
        const filterDataToSave: FilterData = {
          selectedOrganisation: this.selectedOrganisation,
          selectedSite: this.selectedSite
        };
        localStorage.setItem(SETTINGS_FILTER_DATA, JSON.stringify(filterDataToSave));
        this.isLoading = false;
      },
      error: () => {
        this.toastr.error(this.translateService.instant("COMMON.GET_DATA_ERROR"), "", toastrConfig);
        this.isLoading = false;
      }
    })
  }

  saveSettings() {
    this.isLoading = true;

    if (this.settingsData.openTime && this.settingsData.closeTime && this.settingsData.closeIsOnSameDay !== undefined) {
      const isSameDayLogic = this.settingsData.openTime <= this.settingsData.closeTime;
      if (isSameDayLogic !== this.settingsData.closeIsOnSameDay) {
        this.toastr.error(this.translateService.instant("SETTINGS.OPENING_HOURS.INCORRECT_DATA"), "", toastrConfig);
        this.isLoading = false;
        return;
      }
    }

    this.settingsServices.saveSettings(this.selectedSite.id, this.settingsData).subscribe({
      next: (data: SettingsDTO) => {
        this.settingsData = data;
        this.toastr.success(this.translateService.instant("COMMON.SAVE_SUCCESSFULLY"), "", toastrConfig);
        this.isLoading = false;
      },
      error: () => {
        this.toastr.error(this.translateService.instant("COMMON.SAVE_UNSUCCESSFULLY"), "", toastrConfig);
        this.isLoading = false;
      }
    })
  }
}
